import React, { useState } from "react";
import UpdateGroup from "./UpdateGroup";
import "assets/scss/style.css";
import { Trans } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const Group = ({ group, onUpdateGroup, handleDeleteGroup, employees, selectedOrganisation, t }) => {
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [confirmDeleteGroup, setConfirmDeleteGroupModal] = useState(false);

    const handleEdit = () => {
        setShowUpdateModal(true);
    };

    const handleDeleteGroupClick = (e) => {
        setConfirmDeleteGroupModal(true);
    };
    const handleConfirmDelete = async () => {
        await handleDeleteGroup(group);
        setConfirmDeleteGroupModal(false);
    };
    const handleCancelDelete = () => {
        setConfirmDeleteGroupModal(false);
    };

    return (
        <>
            <tbody>
                <td className="text-left"><Trans>{group.group_name}</Trans></td>
                <td className="text-left">{group.employee_count}</td>
                <td  className="text-center">
                    <Button color="primary" onClick={handleEdit}><i className={`fa fa-edit`}></i></Button>
                    <Button color="danger" onClick={handleDeleteGroupClick}><i className={`fa fa-trash`}></i></Button>
                </td>
            </tbody>
            {showUpdateModal && (
                <UpdateGroup
                    group={group}
                    onClose={() => setShowUpdateModal(false)}
                    onSave={onUpdateGroup}
                    employees={employees}
                    selectedOrganisation={selectedOrganisation}
                    t={t}
                />
            )}
            <Modal isOpen={confirmDeleteGroup} toggle={() => setConfirmDeleteGroupModal(false)}>
                <ModalHeader toggle={() => setConfirmDeleteGroupModal(false)}><Trans>Confirm Delete</Trans></ModalHeader>
                <ModalBody>
                    <Trans>Are you sure you want to delete </Trans> <strong>{group?.group_name}</strong>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleConfirmDelete}>
                        <Trans>Delete</Trans>
                    </Button>{' '}
                    <Button color="secondary" onClick={handleCancelDelete}>
                        <Trans>Cancel</Trans>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Group;